import {
  BaseImageProps,
  ImageAnchorStyles,
  ImageProps,
  SphericalImageProps,
} from '@abyss/3d-viewer';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/AssetLabelling/state';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { DEFAULT_COLORS } from '@/constants';

export const useImageSets = () => {
  const locations = useAtomValue(state.locations);
  const showViewpoints = useAtomValue(state.showViewpoints);

  const imageSets = useMemo(() => {
    const rectilinearImages: ImageProps[] = [];
    const sphericalImages: SphericalImageProps[] = [];

    locations?.forEach((location) => {
      if (location.resourcePath) {
        const baseImage: BaseImageProps = {
          id: location.id,
          name: location.name,
          url: getCloudfrontUrl(location.resourcePath),
          position: [location.pose?.x ?? 0, location.pose?.y ?? 0, location.pose?.z ?? 0],
          rotation: [location.pose?.roll ?? 0, location.pose?.pitch ?? 0, location.pose?.yaw ?? 0],
          isVisible: showViewpoints,
        };
        const styles: ImageAnchorStyles = {
          normal: { fillColor: DEFAULT_COLORS.colors[0], linesColor: DEFAULT_COLORS.colors[0] },
        };

        if (location?.imageSensor) {
          rectilinearImages.push({
            ...baseImage,
            width: location.imageSensor?.width,
            height: location.imageSensor?.height,
            focalLength: location.imageSensor?.focalLength,
            cx: location.imageSensor?.cx,
            cy: location.imageSensor?.cy,
            styles,
          });
        } else {
          sphericalImages.push({
            ...baseImage,
            imageYawOffset: location.pose?.yawOffset,
            styles,
          });
        }
      }
    });

    return { sphericalImages, rectilinearImages };
  }, [locations, showViewpoints]);

  return imageSets;
};
